import { memo } from 'react';
import { Image } from '@/hen-ui/atomics/Image';
import { Link } from '@/hen-ui/atomics/Link';
import type { NavItem } from './types';
import { FOCUS_RING } from './subnav.constants';

interface MobileFeaturedCardProps {
  item: NavItem;
}

export const MobileFeaturedCard = memo(function MobileFeaturedCard({
  item,
}: MobileFeaturedCardProps) {
  const card = item.featuredCard;
  const imageAlt = card?.imageAlt ?? item.label;

  return (
    <Link
      href={item.uri}
      underline='none'
      underlineStyle='thin'
      className={`group flex items-start gap-xs ${FOCUS_RING}`}
    >
      <div className='size-mobile-thumbnail flex-shrink-0 overflow-hidden rounded-md bg-neutral-100'>
        {card?.imageUrl && (
          <Image
            src={card.imageUrl}
            alt={imageAlt}
            className='h-full'
            loading='lazy'
          />
        )}
      </div>

      <div className='flex min-w-0 flex-col gap-xxs'>
        {card?.category && (
          <span className='inline-block self-start rounded-max bg-primary-50 px-xxs py-xxs text-l1 font-bold text-primary-700'>
            {card.category}
          </span>
        )}
        <span className='text-b5 font-bold text-body group-hover:text-secondary-700'>
          {item.label}
        </span>
        {(card?.author || card?.date) && (
          <span className='text-l1 text-neutral-500'>
            {card.author ? `By ${card.author}` : ''}
            {card.author && card.date ? ' · ' : ''}
            {card.date ?? ''}
          </span>
        )}
      </div>
    </Link>
  );
});
